import { auth } from "./firebaseconfig";
import { sendEmailVerification } from "firebase/auth";

// Verification check that can be reused across components
export const checkVerification = (navigate) => {
  const user = auth.currentUser;
  
  if (!user) {
    // User is not logged in, redirect to login
    alert("You must be logged in to perform this action.");
    navigate("/login");
    return false;
  }
  
  if (!user.emailVerified) {
    // User is not verified
    const verifyNow = window.confirm(
      "Email verification required. You need to verify your email before performing this action. Would you like to resend the verification email?"
    );
    
    if (verifyNow) {
      sendEmailVerification(user)
        .then(() => {
          alert("Verification email sent. Please check your inbox and verify your email.");
        })
        .catch((error) => {
          console.error("Error sending verification email:", error);
          alert("Error sending verification email. Please try again later.");
        });
    }
    return false;
  }
  
  // User is verified
  return true;
};

// Use this in any form submission or action that requires verification
export const requireVerification = (event, callback, navigate) => {
  event.preventDefault();
  if (checkVerification(navigate)) {
    // User is verified, proceed with the callback
    callback();
  }
}; 